import { Injectable } from '@angular/core';

/**
 * Service for managing PDF export context state
 */
@Injectable({
  providedIn: 'root'
})
export class PdfExportContextService {
  private _isPdfMode = false;
  private _isDataOnlyMode = false;

  /**
   * Check if currently in PDF export mode
   */
  get isPdfMode(): boolean {
    return this._isPdfMode;
  }

  /**
   * Check if in data-only mode (no API calls)
   */
  get isDataOnlyMode(): boolean {
    return this._isDataOnlyMode;
  }

  /**
   * Set PDF export mode
   */
  setPdfMode(value: boolean): void {
    this._isPdfMode = value;
  }

  /**
   * Set data-only mode (no API calls)
   */
  setDataOnlyMode(value: boolean): void {
    this._isDataOnlyMode = value;
  }

  /**
   * Reset all modes
   */
  reset(): void {
    this._isPdfMode = false;
    this._isDataOnlyMode = false;
  }
}
